module.exports = __webpack_public_path__ + "e8f04f273358a07398fa08174af5e461.png";